Ext.define('SA.data.quickreport.QuickReportTemplates', {
    singleton: true,

    areQuickReportsAvailableForCountry(countryCode) {
        return !this.didLoad() || this.hasTypesForCountry(countryCode);
    },

    didLoad() {
        return !!this.data;
    },

    get(country, type) {
        var sections = Ext.clone(this.data[country][type]);

        return new SA.data.quickreport.QuickReportTemplate(country, type, sections);
    },

    getTypesForCountry(country) {
        var sectionsByType = this.data[country];

        return Object.keys(sectionsByType);
    },

    hasTypesForCountry(country) {
        return !!this.data[country];
    },

    loadAll() {
        return this.loaded();
    },

    loaded() {
        var success = data => this.data = data;

        if (!this.promise) {
            this.promise = SA.Ajax.request({resource: 'quickReportTemplates', success});
        }

        return this.promise;
    }
});